import React from 'react';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { UserMessage } from '../LiliUserMessage/UserMessage';
import { CloseButton, CloseButtonColor } from '../LiliCloseButton/CloseButton';

export interface FeatureModalProps {
  title: string;
  onClickOutside?: () => void;
  id: string;
  image: string;
  disclaimer?: string | React.ReactNode;
  buttonText: string;
  secondaryButtonText?: string;
  onClick: () => void;
  isButtonLoading?: boolean;
  content: React.ReactNode;
  stretchButtons?: boolean;
}

const FeatureModal = (props: FeatureModalProps) => {
  const {
    title,
    onClickOutside = () => {},
    id,
    image,
    disclaimer,
    content,
    buttonText,
    secondaryButtonText,
    onClick,
    isButtonLoading,
    stretchButtons,
  } = props;
  return (
    <UserMessage onClick={onClickOutside} id={id}>
      <div className='rounded-[12px] bg-bw00 w-[566px] font-metricR text-bw08'>
        <div className='text-center h-[212px] flex justify-center items-center'>
          <img src={image} alt='feature' className='flex items-center rounded-[12px]' />
          <div className='absolute top-[16px] right-[16px]'>
            <CloseButton id='remove' color={CloseButtonColor.Gray} onClick={onClickOutside} circle />
          </div>
        </div>
        <div className='px-[32px] pt-[32px]'>
          <p className='h-[48px] text-gray-700 text-center leading-[48px] text-[32px]'>{title}</p>
          {content}
        </div>

        <div className={`flex justify-center gap-[14px] mb-[40px] ${stretchButtons ? 'px-[32px]' : 'px-[64px]'}`}>
          {secondaryButtonText && (
            <LiliButton
              title={secondaryButtonText}
              id='cancel'
              onClick={onClickOutside}
              className='h-[44px]'
              type={LiliButtonType.SECONDARY}
            />
          )}
          <LiliButton title={buttonText} id='continue' onClick={onClick} className='h-[44px]' isLoading={isButtonLoading} />
        </div>
        {disclaimer && (
          <div className='border-t border-bw03 px-[32px] pt-[12px] pb-[16px]'>
            <p className='text-[11px] text-bw06 text-center '>{disclaimer}</p>
          </div>
        )}
      </div>
    </UserMessage>
  );
};

export default FeatureModal;
